export default __webpack_public_path__ + "static/media/android_eng_3.88761581.jpg";